import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchCase } from 'entities/insurance-contract/main-info/actions/fetch-main-info';
import { ISpecialPogram, ISpecialPogramState, TError } from 'entities/insurance-contract/special-pogram/types/SpecialPogram-interface';
import { fetchSpecialPogram } from './actions/fetch-special-program';

export const initialSpecialPogramState = {
    InsuranceSumSectionA: "",
    PaymentsToHospitals: "",
    ReserveUnderGuaranteeLetters: "",
    ReserveUnderGuaranteeLettersRehabilitation: "",
    ResidualPremium: ""
};

const initialState: ISpecialPogramState = {
    specialPogram: initialSpecialPogramState,
    isLoadingSpecialPogram: false,
    errorSpecialPogram: [],
    lastFetchTime: null,
    idCase: null,
};

export const specialPogram = createSlice({
    name: 'specialPogram',
    initialState,
    reducers: {
        resetSpecialPogramData: (state) => {
            state.isLoadingSpecialPogram = false;
            state.specialPogram = initialSpecialPogramState;
            state.errorSpecialPogram = [];
            state.lastFetchTime = null;
            state.idCase = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSpecialPogram.pending, (state) => {
                state.isLoadingSpecialPogram = true;
            })
            .addCase(fetchSpecialPogram.fulfilled, (state, action: PayloadAction<{ specialPogram: ISpecialPogram, idCase: string, fetchTime: number }>) => {
                state.isLoadingSpecialPogram = false;
                state.specialPogram = action.payload.specialPogram;
                state.errorSpecialPogram = [];
                state.lastFetchTime = action.payload.fetchTime;
                state.idCase = action.payload.idCase;
            })
            .addCase(fetchSpecialPogram.rejected, (state, action) => {
                state.specialPogram = initialSpecialPogramState;
                state.isLoadingSpecialPogram = false;
                state.lastFetchTime = null;
                state.errorSpecialPogram = action.payload as TError;
            });
    },
});

export const { resetSpecialPogramData } = specialPogram.actions;

export default specialPogram.reducer;